module.exports = __webpack_public_path__ + "static/img/chrome.f8923e1c.png";